module.exports = new __parcel__URL__("CreateWithRovoSpotlightAnimationLight.1a1df728.gif").toString();